import * as Yup from 'yup';
import { useState } from 'react';
import { useFormik, Form, FormikProvider } from 'formik';
import { useNavigate } from 'react-router-dom';
// material
import countryTelephoneCode, {countries} from "country-telephone-code";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactFlagsSelect from "react-flags-select";
import { Stack, TextField, IconButton, InputAdornment } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import RegisterTwo from './RegisterTwo';
// component
import Iconify from '../../../components/Iconify';


const lookup = require('country-code-lookup');
// ----------------------------------------------------------------------

export default function RegisterForm() {
  const navigate = useNavigate();
  const [step, setStep] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [btn, SetBtn] = useState("Continue");
  const [countryCode, setCountryCode] = useState("");
  const [Phone, setPhone] = useState("");
  const RegisterSchema = Yup.object().shape({
    firstName: Yup.string().min(2, 'Too Short!').max(50, 'Too Long!').required('Country code is required e.g +234'),
    lastName: Yup.string().min(2, 'Too Short!').max(50, 'Too Long!').required('Phone is required'),
    email: Yup.string().email('Email must be a valid email address').required('Role is required'),
  });
  const [select, setSelect] = useState("");
  const onSelect = (code) => {    
    const countryData = countryTelephoneCode(code);
    console.log(countryData[0]);
    setSelect(code)
    setCountryCode(countryData[0])
  };
  const formik = useFormik({
    initialValues: {
      firstName: '',
      lastName: '',
      email: '',
    },
    validationSchema: RegisterSchema,
    onSubmit: () => {
      // navigate('/dashboard', { replace: true });
      alert(Phone)
      const body = {
        phone: Phone, 
        country_code: countryCode,
        role: "artisan" 
      };
      fetch(`http://keyedin-nodejs.herokuapp.com/api/v1/auth/register`, {
        body: JSON.stringify(body),
        method: "POST"
      })
      .then(resposne => resposne.json())
      .then(data => {
        console.log(data);
        // setStep(true);
      })
      
    },
    
  });

  const { errors, touched, handleSubmit, isSubmitting, getFieldProps } = formik;

  return (
    <>
      <ToastContainer />
      {
        step === false ?
          <FormikProvider value={formik}>
            <Form autoComplete="off" noValidate onSubmit={(e) => {
              e.preventDefault();
              SetBtn("Please Wait...")
              const body = {
                phone: document.getElementById("phone").value,
                country_code:  countryCode,
                role: "artisan" 
              };
              fetch(`https://keyedin-nodejs.herokuapp.com/api/v1/auth/register`, {
                body: JSON.stringify(body),
                method: "POST",
                headers: {
                  "Content-Type": "application/json"
                }
              })
              .then(resposne => resposne.json())
              .then(data => {
                console.log(data);
                
                if(data.message === "Registration created!"){
                  localStorage.setItem("userInfo", JSON.stringify(data));
                  toast.success("Success !", {
                    position: toast.POSITION.TOP_RIGHT
                  });
                  SetBtn("Success");
                  const userPhone = document.getElementById("phone").value;
                  const userEmail = localStorage.getItem("regEmail");
                  fetch(`http://keyedin-nodejs.herokuapp.com/api/v1/otp/sms/${countryCode}/${userPhone}`, {
                    method: "GET"
                  })
                  .then(response => response.json())
                  .then(data => {
                    localStorage.setItem("userOTP", `${data.otp_code}`);                    
                  })
                  setStep(true);
                }else{
                  toast.error(data.message, {
                    position: toast.POSITION.TOP_RIGHT
                  });
                  SetBtn("Try Again")
                }
                
              })
              .catch(err => {
                alert(`Error: ${err}`);
                SetBtn("Try Again")
              })
            }}>
              
              <Stack spacing={3}>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  

                <ReactFlagsSelect
                  selected={select}
                  onSelect={onSelect}
                  fullWidth
                  className='flags'
                  placeholder="Select Country"
                  countries={["fi", "GB", "NG", "US", "GH", "IE", "IT", "NL", "SE"]}
                />
      
                  <TextField
                    fullWidth
                    label="Phone"
                    id="phone"
                    maxLength={10}
                    onChange={(e) => {
                      alert(e.target.value)
                      setPhone(e.target.value)
                    }}
                    {...getFieldProps('lastName')}
                    error={Boolean(touched.lastName && errors.lastName)}
                    helperText={touched.lastName && errors.lastName}
                  />
                </Stack>
                <TextField
                    fullWidth
                    label="Email"
                    onChange={(e) => {
                      localStorage.setItem("regEmail", e.target.value)
                    }}
                    {...getFieldProps('email')}
                    error={Boolean(touched.email && errors.email)}
                  helperText={touched.email && errors.email}
                  />
                <TextField
                  fullWidth
                  autoComplete="username"
                  type="hidden"
                  value="artisan"
                  label="Role"
                  style={{display: "none"}}
                  error={Boolean(touched.email && errors.email)}
                  helperText={touched.email && errors.email}
                />
      
                
                <LoadingButton fullWidth size="large" type="submit" variant="contained" loading={isSubmitting}>
                  {btn}
                </LoadingButton>
              </Stack>
            </Form>
          </FormikProvider>
          :
          <RegisterTwo />
      }
    </>
  );
}
